



















import { mapActions } from 'vuex';
import DashboardCard from '@/components/cards/dashboards/DashboardCard.vue';

export default {
  name: 'NewDashboardPage',
  components: {
    DashboardCard,
  },
  created() {
    this.setPageTitle({ title: 'New Dashboard', visible: false });
  },
  methods: {
    ...mapActions(['setPageTitle']),
  },
};
